import React, { createContext, useCallback, useMemo, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import { useAsyncSafeState } from 'ui-components/hooks/async-safe';

const SettingsContext = createContext();
const SettingsContextProvider = ({ children }) => {
  const [isNagivationDisabled, setIsNagivationDisabled] = useAsyncSafeState(false);
  const asyncSetIsNavigationDisabled = useCallback(
    async (isDisabled) => {
      setTimeout(() => setIsNagivationDisabled(isDisabled), 50);
    },
    [setIsNagivationDisabled],
  );
  const value = useMemo(() => {
    return {
      isNagivationDisabled,
      setIsNagivationDisabled: asyncSetIsNavigationDisabled,
    };
  }, [isNagivationDisabled, asyncSetIsNavigationDisabled]);

  const { pathname } = useLocation();
  useEffect(() => {
    setIsNagivationDisabled(false);
  }, [setIsNagivationDisabled, pathname]);

  return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
};

SettingsContextProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export { SettingsContext, SettingsContextProvider };
